import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { WelaraAcademyService } from '../../../services/welara-academy.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-welara-academy',
  templateUrl: './welara-academy.component.html',
  styleUrls: ['./welara-academy.component.css']
})
export class WelaraAcademyComponent implements OnInit {
  dropdownSettings: IDropdownSettings = {};
  dropdownList: any[] = [];
  selectedItems: any[] = [];
  errorMsg = "";

  helpAsset = {
    id: "",
    type: "loom_video",
    mode: "add",
    url: "",
    title: "",
    description: "",
    active: 1,
    tags: []
  };

  helpFilters = {
    tags: [],
    active: -1
  };

  isContentLoaded = false;
  listContent: any[] = [];
  listPublications: any[] = [];
  listVideos: any[] = [];
  listImages: any[] = [];
  listLinks: any[] = [];
  listTags: any[] = [];
  showModal = "none";

  authUser = sessionStorage.getItem('wOSAuthUser');
  authAdmin = sessionStorage.getItem('wOSAdmin');
  token!: string;
  ddSettings: IDropdownSettings = {};
  constructor(
    private academyService: WelaraAcademyService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'tag_pretty',
      enableCheckAll: false,
      itemsShowLimit: 12,
      allowSearchFilter: true
    };
    const user: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(user).stsTokenManager.accessToken;
    this.loadAssets();

  }

  loadAssets(): void {
    this.academyService.loadAcademyAssets(this.token)
      .then(data => {
        this.listContent = data.content || [];
        this.listTags = data.tags;

        console.log("Academy data",this.listContent,this.listTags)

        this.listVideos = this.listContent.filter((row: any) => row.content_type.indexOf('loom') > -1);
        this.listPublications = this.listContent.filter((row: any) => row.content_type == 'newsletter' || row.content_type == 'book');
        this.listImages = this.listContent.filter((row: any) => row.content_type == 'image');
        this.listLinks = this.listContent.filter((row: any) => row.content_type == 'link');

      })
      .catch(err => console.error('Error loading assets:', err));
  }

  toggleModal(mode: string): void {
    this.showModal = (mode === 'show') ? 'block' : 'none';
  }

  onTagSelect(item: any) {
    console.log("onTagSelect", this.helpAsset.tags)
  }

  getSafeURL(link: string): SafeHtml {
    const ret = this.sanitizer.bypassSecurityTrustResourceUrl(link); 
    console.log("SafeURL",ret)
    return ret
  }


  saveAcademyAsset(): void {
    try {
      if (!this.helpAsset.url || this.helpAsset.url.trim() === "") {
        this.errorMsg = "URL cannot be blank.";
        setTimeout(() => this.errorMsg = "", 5000);
        return;
      }
      if (!this.helpAsset.title || this.helpAsset.title.trim() === "") {
        this.errorMsg = "Title cannot be blank.";
        setTimeout(() => this.errorMsg = "", 5000);
        return;
      }
      const payload = {
        mode:'add',
        id: this.helpAsset.id ? parseInt(this.helpAsset.id, 10) : null,
        url: this.helpAsset.url,
        title: this.helpAsset.title,
        description: this.helpAsset.description,
        type: this.helpAsset.type,
        active: 1,
        created_by: this.authUser,
        tags: this.helpAsset.tags
      };
  
      console.log('Save Payload:', payload);  // <--- Debugging line
  
      this.academyService.saveAcademyAsset(payload, this.token).then(r => {
        console.log('Save successful!');
        this.toggleModal('hide');
        this.loadAssets();
      })
      
    } catch (error) {
      console.error('Save error:', error);
    }
  }
  
}
